import React from 'react'
import Button from './Button'
import "./Hire.css"

function Hire({title,title_p,desc, btnTitle , link}) {

  return (
    <section className='hire-section'>
       <div className='hire'>
       <p className='hire-title-s'>{title}</p>
        <h5 className='hire-title-p'>{title_p}</h5>
        <p className='hire-desc'>{desc}</p>
        <div className='hire-btn'>
            <Button btnTitle={btnTitle} link={link}/>
        </div>
       </div>
    </section>
  )
}

export default Hire